import OrderDetail from "./OrderDetail";
import OrderHistory from "./OrderHistory";

class Common {
    static chain = {
        OrderDetail: {param_value: 'OrderDetail', element: OrderDetail},
        OrderHistory: {param_value: 'OrderHistory', element: OrderHistory},
    };
    static param_key = '__c';
    static param_key_bomId = 'orderId';
    static redux_key = 'Order__Component__Loader';
    static default_component = Common.chain.OrderHistory;
}

export default Common;